import { FC } from "react";
import styled from "@emotion/styled";
import { MdsSkeletonLoader } from "@/design-system/components/loader/MdsSkeletonLoader";
import { MdsSkeletonLoaderShape } from "@/design-system/components/loader/types";

export const IntegrationsPageSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ContentSkeleton>
        <SectionSkeleton>
          <MdsSkeletonLoader height={16} width={220} shape={MdsSkeletonLoaderShape.Rectangle} />
          <BlockSkeleton>
            <MdsSkeletonLoader height={100} width={320} shape={MdsSkeletonLoaderShape.Rectangle} />
          </BlockSkeleton>
        </SectionSkeleton>
        <SectionSkeleton>
          <MdsSkeletonLoader height={16} width={220} shape={MdsSkeletonLoaderShape.Rectangle} />
          <BlockSkeleton>
            <MdsSkeletonLoader height={100} width={320} shape={MdsSkeletonLoaderShape.Rectangle} />
            <MdsSkeletonLoader height={100} width={320} shape={MdsSkeletonLoaderShape.Rectangle} />
          </BlockSkeleton>
        </SectionSkeleton>
      </ContentSkeleton>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  padding: "16px",
});

const ContentSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
});

const SectionSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
});

const BlockSkeleton = styled.div({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});
